import { boxy } from '../../form/switch/switch';
export const Switch = {
    variants: {
        boxy
    }
};
